import styled, { css, DefaultTheme, FlattenSimpleInterpolation } from 'styled-components';
export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ArrowCommonStyles = (theme: DefaultTheme): FlattenSimpleInterpolation => css`
  content: '';
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  position: absolute;
  top: 50%;
`;

const ContentPxOffset = '32px';
const ArrowTranslate = 'translate(0px, -50%)';
const ArrowPxOffset = '-10px';

export const Content = styled.div<{ $blackTheme?: boolean; $isLeft?: boolean }>(
  ({ theme, $blackTheme, $isLeft }) => css`
    display: none;
    cursor: pointer;
    position: absolute;
    width: 305px;
    font-weight: 400;
    line-height: 18px;
    top: 50%;
    padding: 16px;
    border-radius: 8px;
    color: ${$blackTheme ? theme.colors!.colorWhite : theme.admanColors!.gray.dark.bg0[5]};
    box-shadow: 0 3px 16px -8px ${theme.admanColors!.gray.light.fg1[6]};
    transform: translate(0, -50%);
    background-color: ${$blackTheme ? theme.admanColors!.gray.dark.bg3[1] : theme.admanColors!.gray.light.bg0[0]};
    z-index: 12;
    white-space: break-spaces;

    ${$isLeft
      ? css`
          right: ${ContentPxOffset};
          font-size: 12px;

          &::after {
            ${ArrowCommonStyles(theme)}

            border-right: 10px solid ${$blackTheme
              ? theme.admanColors!.gray.dark.bg3[1]
              : theme.admanColors!.gray.light.bg0[0]};
            transform: ${ArrowTranslate} rotate(180deg);
            right: ${ArrowPxOffset};
          }
        `
      : css`
          left: ${ContentPxOffset};
          font-size: ${theme.spacers!.spacer03};

          &::before {
            ${ArrowCommonStyles(theme)}

            border-right: 10px solid ${$blackTheme
              ? theme.admanColors!.gray.dark.bg3[1]
              : theme.admanColors!.gray.light.bg0[0]};
            transform: ${ArrowTranslate};
            left: ${ArrowPxOffset};
          }
        `}
  `
);

export const TooltipWrapper = styled.div`
  position: relative;
`;

export const Icon = styled.span(
  ({ theme }) => css`
    display: flex;
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    fill: ${theme.admanColors!.gray.light.fg[2]};

    & svg {
      fill: inherit;

      & path {
        fill: inherit;
      }
    }

    &:hover {
      fill: ${theme.admanColors!.gray.light.fg[1]};
      background-color: ${theme.admanColors!.gray.light.bg0[2]};

      & + ${Content} {
        display: block;
      }
    }
  `
);
